import { CSSProperties, FC, ReactNode, useState } from 'react'

import cn from 'classnames'

import ReactModal from 'react-modal'

interface ExpandableImageContainerProps {
  /**
   * The source of the image to be displayed in the expanded modal view.
   */
  src: string
  /**
   * The alt text for the image.
   */
  alt: string
  /**
   * The content to be rendered inside the ExpandableImageContainer. In normal use cases, this should be an Image component.
   */
  children: ReactNode
  /**
   * Class name to add to the button container where `children` is displayed.
   */
  className?: string
  /**
   * Style to apply to the button container where `children` is displayed.
   */
  style?: CSSProperties
}

const ExpandableImageContainer: FC<ExpandableImageContainerProps> = ({ src, alt, children, className, style }) => {
  const [isExpanded, setIsExpanded] = useState(false)

  return (
    <>
      <button
        type="button"
        aria-expanded={isExpanded ? 'true' : 'false'}
        aria-label="Zoom image"
        className={cn('expandable-image-button', className)}
        onClick={() => setIsExpanded((isExpanded) => !isExpanded)}
        style={style}
      >
        {children}
      </button>
      <ReactModal
        isOpen={isExpanded}
        onRequestClose={() => setIsExpanded(false)}
        shouldCloseOnEsc
        shouldFocusAfterRender
        shouldCloseOnOverlayClick
        className="expandable-image-modal"
        overlayClassName="expandable-image-overlay"
      >
        <img src={src} alt={alt} />
      </ReactModal>
    </>
  )
}

export default ExpandableImageContainer
